module.exports = __webpack_public_path__ + "img/dropped-image-5.a059f45e.png";